import Joi from 'joi';

const exceptions = new RegExp(/^\d+$/);

export const ocValidation = Joi.extend({
  messages: {
    onlyNumbers: 'N° de orden de compra permite solo dígitos',
    invalidOc: 'N° de orden de compra consta de 8, 9 u 11 dígitos',
  },
  type: 'orderId',
  rules: {
    validateOc: {
      validate(value, helpers) {
        if (!exceptions.test(value)) return helpers.error('onlyNumbers');
        else if (
          value.length !== 8 &&
          value.length !== 9 &&
          value.length !== 11
        )
          return helpers.error('invalidOc');
        else return true;
      },
    },
  },
});
